// const LOCAL_STORE_JWT = "chim_jwt";
import { LOCAL_STORE_JWT } from "./main";

const getAuthHeader = () => {
  const token = localStorage.getItem(LOCAL_STORE_JWT) || false;

  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
};

export { getAuthHeader };
